import {
	AppShell,
	Text,
	useMantineTheme,
	Image,
	Group,
	Box,
	Container,
	Center,
	MediaQuery,
	Button,
	Loader,
} from "@mantine/core";
import OTPInput from "otp-input-react";
import React, { useState } from "react";
import { ToastContainer } from "react-toastify";
import Footr from "../../components/Footr";
import imageIcon from "../../static/svg/ivistlogin.svg";
import { useDispatch } from "react-redux";
import { inviteOTP } from "../../services/Action/OTPAction";
import { useNavigate } from "react-router-dom";
import {
	showErrorNotification,
	showSuccessNotification,
} from "../../utils/Notifications";
function OTPSetPassword() {
	const theme = useMantineTheme();
	const navigator = useNavigate();
	const [OTP, setOTP] = useState("");
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(false);
	const otpHandler = async () => {
		setLoading(true);
		const data = dispatch(await inviteOTP(OTP));
		if (data.payload.msg === "code matched") {
			setLoading(false);
			showSuccessNotification("Registerd Sucessfully");
			navigator("/setpassword");
		} else {
			setLoading(false);
			showErrorNotification("Inavlid OTP");
		}
	};
	return (
		<>
			<AppShell
				styles={{
					main: {
						position: "relative",
						minHeight: "calc(100vh - 48px)",
						maxHeight: "auto",
						background:
							theme.colorScheme === "dark"
								? theme.colors.ivisit_dark[0]
								: theme.colors.gray[0],
					},
				}}
				footer={<Footr />}
			>
				<div
					className="OTP_btn"
					style={{
						background: "#040F1F",
						margin: "auto",
					}}
				>
					<ToastContainer />
					<Container mt={10} size="xs" px="xs">
						<Group
							style={{
								width: "55%",
								margin: "auto",
							}}
						>
							<Image
								src={imageIcon}
								width="100%"
								pb={30}
								pt={50}
							/>
						</Group>
						<MediaQuery
							smallerThan={500}
							styles={{ fontSize: "1rem", color: "white" }}
						>
							<Text
								style={{ color: "white" }}
								className="OTPText"
								align="center"
								color="white"
								size="xl"
								weight={700}
								pb={20}
							>
								Enter Email Invitation Code
							</Text>
						</MediaQuery>

						<Center className="otpInput" mt={50}>
							<OTPInput
								value={OTP}
								onChange={setOTP}
								autoFocus
								OTPLength={6}
								otpType="number"
								disabled={false}
								securec
							/>
						</Center>
						<Center mt={30}>
							<Button
								onClick={otpHandler}
								style={{
									width: "150px",
									padding: "0px",
									background: "#14B8E1",
								}}
								type="submit"
							>
								Get OTP
							</Button>
						</Center>
						<Box sx={{ maxWidth: 340 }} mx="auto"></Box>
					</Container>
				</div>
				{loading && (
					<div className="LoadingModal">
						<Loader className="LoadingModal_loader" />
					</div>
				)}
			</AppShell>
		</>
	);
}
export default OTPSetPassword;
